export const inferStopOrder = (segments) =>
  segments?.length
    ? segments.map(({ ...rest }, index) => ({
        ...rest,
        stopstartorder: index + 1,
        stopendorder: index + 2,
      }))
    : [];
